/* eslint-disable react/prefer-stateless-function */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface IntOnlineRetailersModel {
    fields: {
        [fields.name]: string;
        [fields.source]: string;
        [fields.link]: LinkFieldValue;
    };
}

const enum fields {
    name = "name",
    source = "source",
    link = "link",
    onlineRetailers = "onlineRetailers",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.onlineRetailers]: IntOnlineRetailersModel[];
    };
}

export interface OnlineRetailersListStyle {
    container?: GridContainerProps;
    imageGridItem?: GridItemProps;
    image?: LazyImageProps;
    retailText?: TypographyProps;
    noImage?: InjectableCss;
}
export const onlineRetailersListStyle: OnlineRetailersListStyle = {
    container: {
        gap: 30,
    },
    imageGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            display: flex;
            justify-content: center;
            padding-bottom: 45px;
        `,
    },

    image: {
        css: css`
            img {
                min-height: 123px;
                max-width: 118px;
            }
        `,
    },
    noImage: {
        css: css`
            min-height: 123px;
            min-width: 118px;
            background-color: #d8d8d8;
        `,
    },
    retailText: {
        css: css`
            display: block;
            color: #33333a;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            padding-top: 8px;
        `,
    },
};

const styles = onlineRetailersListStyle;
type Props = OwnProps;

class IntOnlineRetailers extends React.Component<Props, any> {
    // eslint-disable-next-line no-useless-constructor
    constructor(props: Props) {
        super(props);
    }
    render() {
        if (this.props.fields.onlineRetailers.length === 0) {
            return null;
        }
        const retailers = this.props.fields.onlineRetailers;
        return (
            <GridContainer {...styles.container}>
                {retailers?.map(retail => (
                    <GridItem {...styles.imageGridItem}>
                        <Link href={retail?.fields?.link?.value} target="_blank">
                            {retail?.fields?.source ? (
                                <LazyImage src={retail?.fields?.source} {...styles.image} />
                            ) : (
                                <StyledWrapper {...styles.noImage}></StyledWrapper>
                            )}

                            <Typography {...styles.retailText}>{retail?.fields?.name}</Typography>
                        </Link>
                    </GridItem>
                ))}
            </GridContainer>
        );
    }
}

const onlineRetailersList: WidgetModule = {
    component: IntOnlineRetailers,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.onlineRetailers,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 0,
                fieldDefinitions: [
                    {
                        name: fields.name,
                        displayName: "Retailer Name",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.source,
                        displayName: "Retailer Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: fields.link,
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Url",
                        },
                    },
                ],
            },
        ],
    },
};

export default onlineRetailersList;
